import { fetcher } from '@commenda/utils';

export interface UnlinkAdminChargebeeCustomerParams {
  companyId: number;
  billingCustomerId: string;
}

export interface UnlinkAdminChargebeeCustomerResponse {
  success: boolean;
}

export async function unlinkAdminChargebeeCustomer({
  companyId,
  billingCustomerId,
}: UnlinkAdminChargebeeCustomerParams): Promise<UnlinkAdminChargebeeCustomerResponse> {
  const response = await fetcher(
    `admin/companies/${companyId}/external-connections/chargebee/${billingCustomerId}`,
    { method: 'DELETE' }
  );

  if (!response.ok) {
    const body = (await response.json().catch(() => null)) as {
      message?: unknown;
      error?: unknown;
    } | null;
    const message =
      typeof body?.message === 'string'
        ? body.message
        : Array.isArray(body?.message)
          ? body.message.join(', ')
          : typeof body?.error === 'string'
            ? body.error
            : 'Failed to unlink Chargebee customer';
    throw new Error(message);
  }

  return response.json();
}
